import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClassicLoading } from 'src/components/shared/ClassicLoading';
import { Star } from 'src/components/shared/Star';
import { UserColor } from 'src/models/resort/UserColor';

interface FollowButtonProps {
  isFollowing: boolean;
  isLoading: boolean;
  userColor: UserColor;
  onClick?: () => void;
}
export const FollowButton: React.FC<FollowButtonProps> = ({
  isFollowing,
  isLoading,
  userColor,
  onClick
}) => {
  const { t } = useTranslation('resort');
  const backgroundColor = isFollowing ? userColor.dark : '#ffffff';
  const borderColor = isFollowing ? 'transparent' : userColor.dark;
  const innerColor = isFollowing ? '#ffc700' : 'transparent';
  const strokeColor = isFollowing ? '#ad8700' : userColor.text;

  return (
    <>
      <button
        className={css`
          width: 100%;
          height: 44px;
          border: solid 4px ${borderColor};
          border-radius: 22px;
          font-size: 14px;
          color: ${userColor.text};
          background: ${backgroundColor};
          transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49);
          &:active {
            transform: scale(0.98, 0.95);
          }
          p {
            margin-left: 4px;
          }
        `}
        onClick={onClick}
        disabled={isLoading}
        aria-describedby={isFollowing ? 'aria-unfollow' : undefined}
      >
        <div
          className={css`
            display: flex;
            align-items: center;
            justify-content: center;
          `}
        >
          {(() => {
            if (isLoading) {
              return <ClassicLoading size={32} dotRadius={1.74} color={userColor.text} />;
            } else {
              return (
                <>
                  <Star size={20} innerColor={innerColor} strokeColor={strokeColor} />
                  <p>{isFollowing ? t('following') : t('do_follow')}</p>
                </>
              );
            }
          })()}
        </div>
      </button>
      {isFollowing && (
        <span
          id="aria-unfollow"
          className={css`
            display: none;
          `}
        >
          {t('aria_button_unfollow')}
        </span>
      )}
    </>
  );
};
